module.exports = __webpack_public_path__ + "static/media/automat_symbol.f51e6037.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/images/automat_symbol.png
// module id = 446
// module chunks = 0